export const subscriptionActions = {
  FETCH_PLANS_SUCCEEDED: 'FETCH_PLANS_SUCCEEDED',
  TOGGLE_POPUP: 'TOGGLE_POPUP',
  DISCOUNT: 'DISCOUNT'
}
